import { Helmet } from "react-helmet";
import Hero from "../../components/home/Hero";
import BreadCrumbProduct from "../../components/product/BreadCrumbProduct";
import Content from "../../components/product/Content";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";

export default function Product() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Produk - BPR Palu Anugerah</title>
                <meta name="description" content="Temukan beragam produk dan layanan finansial dari BPR Palu Anugerah untuk memenuhi kebutuhan keuangan Anda." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Produk - BPR Palu Anugerah" />
                <meta property="og:description" content="Temukan beragam produk dan layanan finansial dari BPR Palu Anugerah untuk memenuhi kebutuhan keuangan Anda." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <Hero />
                <BreadCrumbProduct></BreadCrumbProduct>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}